const TIMING_BEFORE = Object.freeze({
  sameDay: 'same_day', // 0
  dayBefore: 'day_before', // 24
  twoDaysBefore: 'two_days_before', // 48
  threeDaysBefore: 'three_days_before', // 72
});

export default TIMING_BEFORE;
